import React, { useState } from "react";
import ReactStrapTable from "components/reactStrapTable";
import { cellRendererCheck, dateFormate } from "utils/columns";
import { Button } from "reactstrap";
import exports from 'assets/icon/export-icon.svg';
import useAxios from "hooks/useAxios";
import { downloadAsExcel } from "utils/helper";
import { toast } from "react-toastify";

const ViewReports = ({
    rowData,
    fileData,
    filters,
    totalSize,
    onPageChange,
    startPage,
    setStartPage,
    sort,
    setSort,
}) => {
    const [state, updateState] = useState({
        filters: filters,
    });

    const API = useAxios();

    let mainCol =
        [7, 8].includes(rowData.reportTypeID) ?
            [{
                dataField: 'date_of_service',
                text: 'Date of Service',
                sort: false,
                width: 140,
                show: true,
                inputType: 'text',
                hideColFilter: true,
                cellRenderer: (row) => dateFormate(row.date_of_service),
            },
            {
                dataField: 'date_prescribed',
                text: 'Date Prescribed',
                sort: false,
                width: 140,
                show: true,
                inputType: 'text',
                hideColFilter: true,
                cellRenderer: (row) => dateFormate(row.date_prescribed),
            },
            {
                dataField: 'rx_number',
                text: 'RX Number',
                sort: false,
                width: 120,
                show: true,
                inputType: 'text',
                hideColFilter: true,
                cellRenderer: (row) => cellRendererCheck(row.rx_number),
            },
            {
                dataField: "fill_number",
                text: 'Fill Number',
                sort: false,
                width: 150,
                show: true,
                inputType: 'text',
                hideColFilter: true,
                cellRenderer: (row) => cellRendererCheck(row.fill_number == 0 ? "0" : row.fill_number),
            },
            {
                dataField: 'ndc',
                text: 'NDC',
                sort: false,
                width: 120,
                show: true,
                inputType: 'text',
                hideColFilter: true,
                cellRenderer: (row) => cellRendererCheck(row.ndc),
            },
            {
                dataField: 'quantity',
                text: 'Quantity Dispensed',
                sort: false,
                width: 100,
                show: true,
                inputType: 'text',
                hideColFilter: true,
                cellRenderer: (row) => cellRendererCheck(row.quantity),
            },
            {
                dataField: 'prescriber_id',
                text: 'Prescriber ID',
                sort: false,
                width: 140,
                show: true,
                inputType: 'text',
                hideColFilter: true,
                cellRenderer: (row) => cellRendererCheck(row.prescriber_id),
            },
            {
                dataField: 'ship_to_location',
                text: 'Service Provider ID',
                sort: false,
                width: 150,
                show: true,
                inputType: 'text',
                hideColFilter: true,
                cellRenderer: (row) => cellRendererCheck(row.ship_to_location),
            },
            {
                dataField: 'contracted_entity_id',
                text: '340B ID',
                sort: false,
                width: 140,
                show: true,
                inputType: 'text',
                hideColFilter: true,
                cellRenderer: (row) => cellRendererCheck(row.contracted_entity_id),
            },
            {
                dataField: "payer_bin",
                text: 'RX BIN',
                sort: false,
                width: 150,
                show: true,
                inputType: 'text',
                hideColFilter: true,
                cellRenderer: (row) => cellRendererCheck(row.payer_bin),
            },
            {
                dataField: "payer_pcn",
                text: 'RX PCN',
                sort: false,
                width: 150,
                show: true,
                inputType: 'text',
                hideColFilter: true,
                cellRenderer: (row) => cellRendererCheck(row.payer_pcn),
            },
            {
                dataField: 'claims_confirm_flag',
                text: 'Claim Status',
                sort: false,
                width: 150,
                show: rowData.statusDesc == "Uploaded" ? true : false,
                inputType: 'text',
                hideColFilter: true,
                cellRenderer: (row) => cellRendererCheck(row.claims_confirm_flag),
            },
            ]
            : [
                {
                    dataField: 'contracted_entity_id',
                    text: 'Entity ID',
                    sort: false,
                    width: 140,
                    show: true,
                    inputType: 'text',
                    hideColFilter: true,
                    cellRenderer: (row) => cellRendererCheck(row.contracted_entity_id),
                },
                {
                    dataField: 'date_of_service',
                    text: 'Date of Service',
                    sort: false,
                    width: 140,
                    show: true,
                    inputType: 'text',
                    hideColFilter: true,
                    cellRenderer: (row) => dateFormate(row.date_of_service),
                },
                {
                    dataField: 'date_prescribed',
                    text: 'Date Prescribed',
                    sort: false,
                    width: 140,
                    show: true,
                    inputType: 'text',
                    hideColFilter: true,
                    cellRenderer: (row) => dateFormate(row.date_prescribed),
                },
                {
                    dataField: 'ndc',
                    text: 'NDC',
                    sort: false,
                    width: 120,
                    show: true,
                    inputType: 'text',
                    hideColFilter: true,
                    cellRenderer: (row) => cellRendererCheck(row.ndc),
                },
                {
                    dataField: 'prescriber_id',
                    text: 'Prescriber ID',
                    sort: false,
                    width: 140,
                    show: [2, 6].includes(rowData.reportTypeID) ? true : false,
                    inputType: 'text',
                    hideColFilter: true,
                    cellRenderer: (row) => cellRendererCheck(row.prescriber_id),
                },
                {
                    dataField: 'prescriber_id_qualifier',
                    text: 'Prescriber ID Qualifier',
                    sort: false,
                    width: 140,
                    show: [2, 6].includes(rowData.reportTypeID) ? true : false,
                    inputType: 'text',
                    hideColFilter: true,
                    cellRenderer: (row) => cellRendererCheck(row.prescriber_id_qualifier),
                },
                {
                    dataField: 'quantity',
                    text: 'Quantity',
                    sort: false,
                    width: 100,
                    show: true,
                    inputType: 'text',
                    hideColFilter: true,
                    cellRenderer: (row) => cellRendererCheck(row.quantity),
                },
                {
                    dataField: 'rx_number',
                    text: 'RX Number',
                    sort: false,
                    width: 120,
                    show: true,
                    inputType: 'text',
                    hideColFilter: true,
                    cellRenderer: (row) => cellRendererCheck(row.rx_number),
                },
                {
                    dataField: 'service_provider_id',
                    text: 'Service Provider ID',
                    sort: false,
                    width: 150,
                    show: true,
                    inputType: 'text',
                    hideColFilter: true,
                    cellRenderer: (row) => cellRendererCheck(row.service_provider_id),
                },
                {
                    dataField: 'service_provider_id_qualifier',
                    text: 'Service Provider ID Qualifier',
                    sort: false,
                    width: 150,
                    show: [2, 6].includes(rowData.reportTypeID) ? true : false,
                    inputType: 'text',
                    hideColFilter: true,
                    cellRenderer: (row) => cellRendererCheck(row.service_provider_id_qualifier),
                },
                {
                    dataField: "wholesaler_invoice_number",
                    text: 'Wholesaler Invoice Number',
                    sort: false,
                    width: 150,
                    show: [2, 6].includes(rowData.reportTypeID) ? true : false,
                    inputType: 'text',
                    hideColFilter: true,
                    cellRenderer: (row) => cellRendererCheck(row.wholesaler_invoice_number),
                },
                {
                    dataField: "payer_bin",
                    text: 'Payer BIN',
                    sort: false,
                    width: 150,
                    show: [2, 6].includes(rowData.reportTypeID) ? true : false,
                    inputType: 'text',
                    hideColFilter: true,
                    cellRenderer: (row) => cellRendererCheck(row.payer_bin),
                },
                {
                    dataField: "payer_pcn",
                    text: 'Payer PCN',
                    sort: false,
                    width: 150,
                    show: [2, 6].includes(rowData.reportTypeID) ? true : false,
                    inputType: 'text',
                    hideColFilter: true,
                    cellRenderer: (row) => cellRendererCheck(row.payer_pcn),
                },
                {
                    dataField: "ship_to_date",
                    text: 'Ship To Date',
                    sort: false,
                    width: 150,
                    show: [2, 6].includes(rowData.reportTypeID) ? true : false,
                    inputType: 'text',
                    hideColFilter: true,
                    cellRenderer: (row) => dateFormate(row.ship_to_date),
                },
                {
                    dataField: "ship_to_location",
                    text: 'Ship To Location',
                    sort: false,
                    width: 150,
                    show: [2, 6].includes(rowData.reportTypeID) ? true : false,
                    inputType: 'text',
                    hideColFilter: true,
                    cellRenderer: (row) => cellRendererCheck(row.ship_to_location),
                },
                {
                    dataField: "account_340b",
                    text: 'Account 340B',
                    sort: false,
                    width: 150,
                    show: [2, 6].includes(rowData.reportTypeID) ? true : false,
                    inputType: 'text',
                    hideColFilter: true,
                    cellRenderer: (row) => cellRendererCheck(row.account_340b),
                },
                {
                    dataField: "product_serialization_number",
                    text: 'Product Serialization Number',
                    sort: false,
                    width: 150,
                    show: [2, 6].includes(rowData.reportTypeID) ? true : false,
                    inputType: 'text',
                    hideColFilter: true,
                    cellRenderer: (row) => cellRendererCheck(row.product_serialization_number),
                },
                {
                    dataField: "fill_number",
                    text: 'Fill Number',
                    sort: false,
                    width: 150,
                    show: [2, 6].includes(rowData.reportTypeID) ? true : false,
                    inputType: 'text',
                    hideColFilter: true,
                    cellRenderer: (row) => cellRendererCheck(row.fill_number == 0 ? "0" : row.fill_number),
                },
                {
                    dataField: 'claims_confirm_flag',
                    text: 'Claim Status',
                    sort: false,
                    width: 150,
                    show: rowData.statusDesc == "Uploaded" ? true : false,
                    inputType: 'text',
                    hideColFilter: true,
                    cellRenderer: (row) => cellRendererCheck(row.claims_confirm_flag),
                },
                // {
                //     dataField: 'formatted_rx_number',
                //     text: 'Formatted RX Number',
                //     sort: false,
                //     width: 150,
                //     show: rowData.autoSend == 'Y'? true : false,
                //     inputType: 'text',
                //     hideColFilter: true,
                //     cellRenderer: (row) => cellRendererCheck(row.formatted_rx_number),
                // },
            ];

    let SBmainCol = [
        {
            dataField: '340b_id',
            text: '340B ID',
            sort: false,
            width: 140,
            show: true,
            inputType: 'text',
            hideColFilter: true,
            cellRenderer: (row) => cellRendererCheck(row['340b_id']),
        },
        {
            dataField: 'claim_number',
            text: 'Claim Number',
            sort: false,
            width: 140,
            show: true,
            inputType: 'text',
            hideColFilter: true,
            cellRenderer: (row) => cellRendererCheck(row.claim_number),
        },
        {
            dataField: 'claim_line_number',
            text: 'Claim Line Number',
            sort: false,
            width: 100,
            show: true,
            inputType: 'text',
            hideColFilter: true,
            cellRenderer: (row) => cellRendererCheck(row.claim_line_number),
        },
        {
            dataField: 'date_of_service',
            text: 'Date of Service',
            sort: false,
            width: 140,
            show: true,
            inputType: 'text',
            hideColFilter: true,
            cellRenderer: (row) => dateFormate(row.date_of_service),
        },
        {
            dataField: 'hcpcs_code',
            text: 'HCPCS Code',
            sort: false,
            width: 120,
            show: true,
            inputType: 'text',
            hideColFilter: true,
            cellRenderer: (row) => cellRendererCheck(row.hcpcs_code),
        },
        {
            dataField: 'hcpcs_code_modifier_1',
            text: 'HCPCS Code Modifier 1',
            sort: false,
            width: 140,
            show: true,
            inputType: 'text',
            hideColFilter: true,
            cellRenderer: (row) => cellRendererCheck(row.hcpcs_code_modifier_1),
        },
        {
            dataField: 'hcpcs_code_modifier_2',
            text: 'HCPCS Code Modifier 2',
            sort: false,
            width: 140,
            show: true,
            inputType: 'text',
            hideColFilter: true,
            cellRenderer: (row) => cellRendererCheck(row.hcpcs_code_modifier_2),
        },
        {
            dataField: 'hcpcs_code_modifier_3',
            text: 'HCPCS Code Modifier 3',
            sort: false,
            width: 140,
            show: true,
            inputType: 'text',
            hideColFilter: true,
            cellRenderer: (row) => cellRendererCheck(row.hcpcs_code_modifier_3),
        },
        {
            dataField: 'hcpcs_code_modifier_4',
            text: 'HCPCS Code Modifier 4',
            sort: false,
            width: 140,
            show: true,
            inputType: 'text',
            hideColFilter: true,
            cellRenderer: (row) => cellRendererCheck(row.hcpcs_code_modifier_4),
        },
        {
            dataField: 'health_plan_name',
            text: 'Health Plan Name',
            sort: false,
            width: 240,
            show: true,
            inputType: 'text',
            hideColFilter: true,
            cellRenderer: (row) => cellRendererCheck(row.health_plan_name),
        },
        {
            dataField: 'health_plan_id',
            text: 'Health Plan ID',
            sort: false,
            width: 200,
            show: true,
            inputType: 'text',
            hideColFilter: true,
            cellRenderer: (row) => cellRendererCheck(row.health_plan_id),
        },
        {
            dataField: 'ndc_11',
            text: 'NDC',
            sort: false,
            width: 120,
            show: true,
            inputType: 'text',
            hideColFilter: true,
            cellRenderer: (row) => cellRendererCheck(row.ndc_11),
        },
        {
            dataField: 'rendering_physician_id',
            text: 'Rendering Physician ID',
            sort: false,
            width: 150,
            show: true,
            inputType: 'text',
            hideColFilter: true,
            cellRenderer: (row) => cellRendererCheck(row.rendering_physician_id),
        },
        {
            dataField: 'quantity',
            text: 'Quantity',
            sort: false,
            width: 100,
            show: true,
            inputType: 'text',
            hideColFilter: true,
            cellRenderer: (row) => cellRendererCheck(row.quantity),
        },
        {
            dataField: 'unit_of_measure',
            text: 'Unit Of Measure',
            sort: false,
            width: 150,
            show: true,
            inputType: 'text',
            hideColFilter: true,
            cellRenderer: (row) => cellRendererCheck(row.unit_of_measure),
        },

        {
            dataField: 'service_provider_id',
            text: 'Service Provider ID',
            sort: false,
            width: 150,
            show: true,
            inputType: 'text',
            hideColFilter: true,
            cellRenderer: (row) => cellRendererCheck(row.service_provider_id),
        },

        {
            dataField: "wholesaler_invoice_number",
            text: 'Wholesaler Invoice Number',
            sort: false,
            width: 150,
            show: rowData.reportTypeID == 13 ? false : true,
            inputType: 'text',
            hideColFilter: true,
            cellRenderer: (row) => cellRendererCheck(row.wholesaler_invoice_number),
        },
        {
            dataField: 'claims_confirm_flag',
            text: 'Claim Status',
            sort: false,
            width: 150,
            show: rowData.statusDesc == "Uploaded" ? true : false,
            inputType: 'text',
            hideColFilter: true,
            cellRenderer: (row) => cellRendererCheck(row.claims_confirm_flag),
        },
        // {
        //     dataField: 'formatted_claim_number',
        //     text: 'Formatted Claim Number',
        //     sort: false,
        //     width: 150,
        //     show: rowData.autoSend == 'Y'? true : false,
        //     inputType: 'text',
        //     hideColFilter: true,
        //     cellRenderer: (row) => cellRendererCheck(row.formatted_claim_number),
        // },
    ];

    const setState = (state) => updateState((pre) => ({ ...pre, ...state }));

    const handleSort = (filter, hasColFilter) => {
        setState({
            filters: filter,
        });
        if (hasColFilter) {
            onPageChange(filter, true);
        } else {
            onPageChange(filter);
            setSort(true)
        }
    };

    const onPageSizeChange = (filter, hasColFilter, colChangedFilter) => {
        if (hasColFilter) {
            setState({
                filters: filter,
            });
            let colFilterOn = { ...filter, filters: colChangedFilter };
            return onPageChange(colFilterOn, true);
        }
        setState({
            filters: filter,
        });
        onPageChange(filter);
    };

    const onHandlePageChange = (filter, hasColFilter, colChangedFilter) => {
        if (hasColFilter) {
            setState({
                filters: filter,
            });
            let colFilterOn = { ...filter, filters: colChangedFilter };
            onPageChange(colFilterOn, true);
        } else {
            setState({
                filters: filter,
            });
            onPageChange(filter);
        }
    };

    const onHandleExport = async () => {
        if (!totalSize || totalSize <= 0) {
            toast.error('No Records Found');
            return;
        }

        const payload = {
            encryptedReportDetailId: rowData.encryptedReportDetailsID,
            filters: filters.filters || [],
            order: filters.order || "createddate",
            orderBy: filters.orderBy || "desc",
            currentPage: 1,
            pageSize: totalSize,
        };

        let APIURL = ""
        if (rowData.appID == 2003) {
            APIURL = 'api/Report/medReportDetailItemGrid'
        }
        else {
            APIURL = "api/Report/phReportDetailItemGrid"
        }
        try {
            const { data } = await API.post(APIURL, payload,
                {
                    hasDefaultURL: true,
                }
            );

            if (!data?.items?.length) {
                toast.error('No Records Found');
                return;
            }

            const visibleColumns = rowData.appID == 2003 ? SBmainCol.filter((col) => col.show) : mainCol.filter((col) => col.show);
            const headers = visibleColumns.map((col) => col.text);
            const rows = data.items.map((row) =>
                visibleColumns.map((col) => {
                    const value = col.cellRenderer ? col.cellRenderer(row) : row[col.dataField];
                    return value == null || value === '' ? '-' : value;
                })
            );

            const fileName = rowData.fileName
                ? rowData.fileName
                : 'report.xls';

            downloadAsExcel(headers, rows, fileName);
        } catch (error) {
            console.log(error);
        }
    };

    return (
        <>
            <div className='table-card scroll-table position-relative border-0 rounded pt-0'
                fixed-height-table='fixed-height-table' >
                <div className="d-flex justify-content-end py-1">
                    <Button
                        color="primary"
                        className="btn-export"
                        onClick={onHandleExport}
                    >
                        <span className='right_5'> <img src={exports} alt="" /></span>
                        Export
                    </Button>
                </div>
                <ReactStrapTable
                    id='view-table'
                    // id='configuration-table'
                    height={550}
                    width={1200}
                    data={fileData}
                    columns={rowData.appID == 2003 ? SBmainCol : mainCol}
                    totalRecords={totalSize}
                    handleSort={handleSort}
                    onPageChange={onHandlePageChange}
                    onPageSizeChange={onPageSizeChange}
                    hasDefaultPagination={true}
                    startPage={startPage}
                    setStartPage={setStartPage}
                    filters={filters}
                    pageSize={filters.pageSize}
                    currentPage={filters.currentPage}
                    sort={sort}
                    setSort={setSort}
                    hasExportPermission={false}
                >
                </ReactStrapTable>
            </div>
        </>
    )

}

export default ViewReports